/**
 * What the studio owner actually gets. Outcome-led, not feature-led.
 *
 * `visual` picks the small illustration drawn on each tile in ValueProps.vue.
 */

export const valueProps = [
  {
    icon: "IconClock",
    visual: "schedule",
    title: "קבלו את הזמן שלכם בחזרה",
    text: "אין יותר רישום לאימונים בוואטסאפ בין שיעור לשיעור. הלו״ז מתנהל לבד, ואתם מתמקדים באימון עצמו.",
  },
  {
    icon: "IconUsers",
    visual: "capacity",
    title: "אימונים מלאים יותר",
    text: "רשימת המתנה שמעדכנת על מקומות פנויים, ותזכורות שמקטינות אי-הגעות.",
  },
  {
    icon: "IconGlobe",
    visual: "calendar",
    title: "שליטה בסטודיו מכל מקום",
    text: "היומן, הקבוצות הכרטיסיות והמנויים זמינים מהנייד בכל שעה — גם כשאתם לא בסטודיו.",
  },
  {
    icon: "IconChart",
    visual: "progress",
    title: "ביצועים ושיפורים",
    text: "מעקב מדידות והתקדמות, כמות וזמני אימונים",
  },
];
